const WORKFLOW_VERSION_HISTORY_PREVIEW_LIMIT = 3;

function workflowVersionCreatedAtUnixSeconds(version) {
    const ca = version?.createdAt;
    if (ca == null) return 0;
    if (typeof ca === "number") {
        return ca > 1e12 ? Math.floor(ca / 1000) : Math.floor(ca);
    }
    if (typeof ca === "string") {
        const ms = Date.parse(ca);
        return Number.isNaN(ms) ? 0 : Math.floor(ms / 1000);
    }
    if (ca instanceof Date) {
        const ms = ca.getTime();
        return Number.isNaN(ms) ? 0 : Math.floor(ms / 1000);
    }
    if (typeof ca === "object") {
        if (typeof ca._seconds === "number") return ca._seconds;
        if (typeof ca.seconds === "number") return ca.seconds;
        if (typeof ca.toMillis === "function") {
            try {
                return Math.floor(ca.toMillis() / 1000);
            } catch {
                return 0;
            }
        }
        if (typeof ca.toDate === "function") {
            try {
                const d = ca.toDate();
                return d instanceof Date && !Number.isNaN(d.getTime())
                    ? Math.floor(d.getTime() / 1000)
                    : 0;
            } catch {
                return 0;
            }
        }
    }
    return 0;
}

function workflowVersionSortKey(version) {
    const fromTime = workflowVersionCreatedAtUnixSeconds(version);
    if (fromTime > 0) {
        return fromTime;
    }
    const idNum = Number(version?.id);
    if (Number.isFinite(idNum) && idNum > 0) {
        return Math.floor(idNum / 1000);
    }
    return 0;
}

function sortWorkflowVersionsByCreatedAtDesc(versions) {
    return [...versions].sort((a, b) => workflowVersionSortKey(b) - workflowVersionSortKey(a));
}

function isVersionInWorkflowHistoryPreview(
    versionId,
    versions,
    limit = WORKFLOW_VERSION_HISTORY_PREVIEW_LIMIT
) {
    const sorted = sortWorkflowVersionsByCreatedAtDesc(versions);
    const allowed = new Set(sorted.slice(0, limit).map((v) => v.id));
    return allowed.has(versionId);
}

module.exports = {
    WORKFLOW_VERSION_HISTORY_PREVIEW_LIMIT,
    workflowVersionCreatedAtUnixSeconds,
    workflowVersionSortKey,
    sortWorkflowVersionsByCreatedAtDesc,
    isVersionInWorkflowHistoryPreview
};
